import React from 'react';
import { motion } from 'framer-motion';
import { OpenFpgaLogo } from './OpenFpgaLogo';
interface SlideLayoutProps {
  children: React.ReactNode;
  slideNumber: number;
  totalSlides: number;
  title?: string;
  hideLogo?: boolean;
}
export function SlideLayout({
  children,
  slideNumber,
  totalSlides,
  title,
  hideLogo = false
}: SlideLayoutProps) {
  return <div className="relative w-full h-full flex flex-col p-8 md:p-12 lg:p-16 max-w-[1920px] mx-auto" data-id="element-21">
      {/* Header */}
      <header className="flex justify-between items-center mb-8 h-16" data-id="element-22">
        {!hideLogo && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-23">
            <OpenFpgaLogo size="sm" data-id="element-24" />
          </motion.div>}

        {title && <motion.h2 initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="absolute left-0 right-0 text-center text-brand-muted text-sm font-mono uppercase tracking-widest pointer-events-none" data-id="element-25">
            {title}
          </motion.h2>}
      </header>

      {/* Main Content */}
      <main className="flex-1 relative z-10 flex flex-col justify-center overflow-y-auto" data-id="element-26">
        {children}
      </main>

      {/* Footer / Progress */}
      <footer className="absolute bottom-16 left-0 right-0 flex justify-center items-center pointer-events-none" data-id="element-27">
        <div className="text-brand-muted text-xs font-mono opacity-40" data-id="element-28">
          {slideNumber} / {totalSlides}
        </div>
      </footer>

      {/* Background Elements - Subtle Grid or Glow */}
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-29">
        <div className="absolute top-[-20%] right-[-10%] w-[40%] h-[40%] bg-brand-primary/5 rounded-full blur-[100px]" data-id="element-30" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[30%] h-[30%] bg-chip-tpu/5 rounded-full blur-[100px]" data-id="element-31" />
      </div>
    </div>;
}